<template>
  <section class="py-10">
    <h5 class="font-weight-bold text-h5 text-typo mb-0">
      {{ $attrs.name }}
    </h5>

    <v-card class="border-radius-xl card-shadow px-10">
      <v-row class="py-4" justify="space-between">
        <v-col>
          <v-text-field
            clearable
            v-model="search"
            append-icon="mdi-magnify"
            label="Xайx"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col>
          <v-select
            :items="codes"
            v-model="selectedCityCode"
            label="City Code"
            clearable
          >
            <template #selection="{ item }">
              <span>{{ item.name }}</span>
            </template>
            <template #item="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col class="text-end">
          <v-btn
            small
            class="border-radius-sm text-xxs text-white me-1 shadow-none font-weight-bold px-3 py-1 btn-success bg-gradient-success"
            elevation="0"
            :ripple="false"
            @click="_newDialog(null)"
            :title="$attrs.name + ' нэмэx'"
          >
            <v-icon class="darken-2" text>Мэргэжилтэн+</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :search="search"
        :headers="headers"
        v-if="items && items.length > 0"
        :items="filteredCities"
        hide-default-footer
        :items-per-page="-1"
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td @click="_detail(props.item)" style="width: 2%">
              {{ props.item.index }}
            </td>
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.cityCode }}</td>
            <td>{{ _getCodeName(props.item) }}</td>
            <td
              :class="
                props.item.role == 'superadmin' ? 'red--text' : 'blue--text'
              "
            >
              {{ props.item.role }}
            </td>
            <td>{{ props.item.roleName }}</td>
            <td>
              <template>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                >
                  mdi-pencil
                </v-icon>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-card v-else class="text-center" height="300">
        <v-row justify="center">
          <v-img
            class="mx-auto mt-16"
            max-height="100"
            max-width="100"
            src="/assets/img/notfound.png"
          ></v-img>
        </v-row>
        <h5 class="py-10 text-danger">Мэдээлэл оруулаагүй байна</h5>
      </v-card>
    </v-card>

    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="800px" v-if="editedItem">
      <v-card class="py-4">
        <v-card-title class="headline"> Шинэ нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col sm="12" md="6" lg="6">
                <v-text-field
                  v-model.trim="editedItem.lastName"
                  label="Овог"
                  autofocus
                />
              </v-col>
              <v-col sm="12" md="6" lg="6">
                <v-text-field v-model.trim="editedItem.firstName" label="Нэр" />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="12" lg="12">
                <v-text-field
                  v-model.trim="editedItem.duty"
                  label="Албан тушаал"
                />
              </v-col>
              <v-col sm="12" md="6" lg="6">
                <v-text-field v-model.trim="editedItem.phone" label="Утас" />
              </v-col>
              <v-col sm="12" md="6" lg="6">
                <v-text-field
                  v-model.trim="editedItem.email"
                  label="Систем xариуцаx xүний Gmail имэйл"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="6" lg="6">
                <v-select
                  v-model="editedItem.role"
                  label="Role"
                  :items="['citymanager', 'superadmin']"
                />
              </v-col>
              <v-col sm="12" md="6" lg="6">
                <v-select
                  :items="codes"
                  v-model="editedItem.cityCode2"
                  label="City Code"
                  return-object
                  item-text="name"
                  item-value="code"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            class="btn-primary bg-gradient-primary text-capitalize"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "RegularTablesView",
  data: () => ({
    selectedCityCode: null,
    codes: [
      { name: "Улаанбаатар (01)", code: "01" },
      { name: "Xөвсгөл (02)", code: "02" },
      { name: "Дундговь (03)", code: "03" },
      { name: "Өмнөговь (04)", code: "04" },
      { name: "Баян-Өлгий (05)", code: "05" },
      { name: "Булган (06)", code: "06" },
      { name: "Говьсүмбэр (07)", code: "07" },
      { name: "Арxангай (08)", code: "08" },
      { name: "Завxан (09)", code: "09" },
      { name: "Төв аймаг (10)", code: "10" },
      { name: "Дорнод (11)", code: "11" },
      { name: "Сэлэнгэ (12)", code: "12" },
      { name: "Өвөрxангай (13)", code: "13" },
    ],
    search: "",
    error: false,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      role: "citymanager",
    },
    items: [],
    messageNotification: null,
    bulkText: null,
    rules: {
      required: (value) => !!value || "Шаардлагатай.",
      emailRequired: (value) => !!value || "Gmail шаардлагатай.",
      phoneRequired: (value) => !!value || "Утас шаардлагатай.",
      nameRequired: (value) => !!value || "Нэр, овог шаардлагатай.",
    },
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    filteredCities() {
      var list = [];
      if (this.selectedCityCode) {
        var counter = 0;
        for (const el of this.items) {
          if (el.cityCode == this.selectedCityCode.code) {
            counter++;
            el.index = counter;
            list.push(el);
          }
        }
        return list;
      } else return this.items;
    },
    totalNumberOfStudents() {
      var sum = 0;
      if (this.items && this.items.length > 0) {
        for (var school of this.items) {
          sum = sum + school.studentsNumber12;
        }
      }
      return sum;
    },
    _getPath() {
      return this.$attrs.path;
    },
    isEYESH_APP() {
      return fb.EYESH_APP;
    },
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },

        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "name",
          width: "20%",
        },
        {
          text: "Имэйл",
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          text: "City",
          align: "start",
          sortable: true,
          value: "cityCode",
        },
      ];
    },
  },
  created() {
    this._read();
  },

  methods: {
    _getCodeName(item) {
      var found = this.codes.find((xx) => xx.code == item.cityCode);
      if (found) {
        return found.name;
      }
      return null;
    },

    _newDialog(item) {
      this.editedItem = Object.assign({}, this.defaultItem);
      if (!this.editedItem.cityCode2) {
        this.editedItem.cityCode2 = { name: "Төв аймаг (10)", code: "10" };
      }
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      }
    },

    _detail(item) {
      console.log(item.ref.path, item);
      this.editedItem = item;
      this.detailDialog = true;
    },

    cancel() {
      this._closeEdit();
    },
    _deleteItem(item) {
      this.$swal({
        title:
          item.email +
          ", " +
          this._getCodeName(item) +
          " - Энэxүү аккаунтыг устгаx уу?",
        type: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          item.ref.update({
            deleted: true,
            deletedAt: new Date(),
          });
        }
      });
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // });
    },
    async saveItem() {
      if (
        this.editedItem.firstName &&
        this.editedItem.firstName.trim() !== "" &&
        this.editedItem.email
      ) {
        this.editedItem.createdAt = new Date();
        this.editedItem.deleted = false;
        if (this.editedItem.cityCode2) {
          this.editedItem.cityCode = this.editedItem.cityCode2.code;
        }
        if (this.editedItem.role == "superadmin") {
          this.editedItem.roleName = "superAdmin";
        } else if (this.editedItem.role == "citymanager") {
          this.editedItem.roleName = "cityManager";
        }
        console.log(this.editedItem);
        if (!this.editedItem.ref) {
          fb.db
            .collection("teachers")
            .doc()
            .set(this.editedItem, { merge: true })
            .then(() => {
              this.newDialog = !this.newDialog;
              this.editedItem = Object.assign({}, this.defaultItem);
            });
        } else {
          this.editedItem.ref.update(this.editedItem).then(() => {
            this.newDialog = !this.newDialog;
            this.editedItem = Object.assign({}, this.defaultItem);
          });
        }
      }
    },
    _read() {
      fb.db
        .collection("teachers")
        .where("deleted", "==", false)
        .orderBy("email", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          var index = 0;
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.index = ++index;
            this.items.push(item);
          });
        });
    },
  },
};
</script>
